import React from "react";
import "./Machining.css";
import img59 from "../assets/img59.jpg";
import img60 from "../assets/img60.jpg";
import img61 from "../assets/img61.jpg";
import img62 from "../assets/img62.jpg";
import img63 from "../assets/img63.jpg";
import img64 from "../assets/img64.jpg";
import img65 from "../assets/img65.jpg";
import img66 from "../assets/img66.jpg";
import img67 from "../assets/img67.jpg";
import img68 from "../assets/img68.jpg";
import img69 from "../assets/img69.jpg";
import img70 from "../assets/img70.jpg";
import img71 from "../assets/img71.jpg";
import img72 from "../assets/img72.jpg";
import img73 from "../assets/img73.jpg";
import img74 from "../assets/img74.jpg";
import img75 from "../assets/img75.jpg";
import img76 from "../assets/img76.jpg";
import img77 from "../assets/img77.jpg";
import img78 from "../assets/img78.jpg";
import img79 from "../assets/img79.jpg";
import img80 from "../assets/img80.jpg";
import img81 from "../assets/img81.jpg";
import img82 from "../assets/img82.jpg";


const instruments = [
    {
        title: "Zeiss Contura CMM",
        img: img59,
        specs: [
            "900x1600x800 mm",
            "Fixed Probe Head-Vast XT",
            "MPE : ±1.7 + L/333 µm"
        ]
    },
    {
        title: "Zeiss Prismo CMM",
        img: img60,
        specs: [
            "900x1800x700 mm",
            "Fixed Probe Head-Vast XT",
            "MPE : ±1.7 + L/300 µm"
        ]
    },
    {
        title: "Zeiss Duramax CMM",
        img: img61,
        specs: [
            "500x500x500 mm",
            "Fixed Probe Head-Vast XXT",
            "MPE : ±2.4 + L/300 µm"
        ]
    },
    {
        title: "Hexagon Global Adv. CMM",
        img: img62,
        specs: [
            "900x2000x800 mm",
            "Fixed Probe Head-Leitz S5",
            "MPE : ±1.5 + (3L/1000) µm"
        ]
    },
    {
        title: "Zeiss Spectrum CMM",
        img: img63,
        specs: [
            "700x700x600 mm",
            "Fixed Probe Head-Vast XXT",
            "MPE : ±1.7 + L/333 µm"
        ]
    },
    {
        title: "Contracer 1600G / 2600G",
        img: img64,
        specs: [
            "Range : ± 25 mm & 100mm",
            "Column Type",
            "Accuracy : 1 m /100mm"
        ]
    },
    {
        title: "Surface tester Cum Contracer 1800G",
        img: img65,
        specs: [
            "For Contracer : -",
            "Range : ± 25 mm & 100mm",
            "Accuracy : 1 m /100mm",
            "Column Type",
            "For Roughness : -",
            "Range : ±0.8mm & 100mm",
            "Accuracy : 0.05+1.5L/1000 m"
        ]
    },
    {
        title: "Profile Projector",
        img: img66,
        specs: [
            "Range : 250 x 150mm –Ø400",
            "Vertical Type",
            "Magnification : 10x",
            "Accuracy: ±0.005% on contour"
        ]
    },
    {
        title: "Video Measuring Machine",
        img: img67,
        specs: [
            "Range : 300 x 200 x 200mm",
            "Column Type",
            "Accuracy : 1 m /100mm",
            "Video : 1.3 MP CMOS",
            "Imaging optics : 1:6.5x Magnification",
            "Accuracy (Exy) : ±2.5+L/175mm"
        ]
    },
    {
        title: "Roundness tester",
        img: img68,
        specs: [
            "Range : for ID 360mm & for ",
            "OD 300mm & Z axis – 500mm",
            "Column Type",
            "Rotational Accuracy :",
            "0.02+3.2H/10000 m",
            "Straightness Accuracy :",
            "0.10m/100mm"
        ]
    },
    {
        title: "Portable Roughness Tester",
        img: img69,
        specs: [
            "Traversing length : 15 mm",
            "Measuring type : Skidded probe",
            "Cut off : 0.25mm, 0.8mm, 2.5mm",
            "Parameters to check : Over 30 characteristic values for R-profile in accordance with current ISO/JIS/ASME/Motif standardization"
        ]
    },
    {
        title: "2-D Height Gauge",
        img: img70,
        specs: [
            "Range : 0-600 mm",
            "L.C : 0.0001 mm",
            "Error Limit : 1.8 + L/600 m"
        ]
    },
    {
        title: "Accurate CMM with Revo Probe Head",
        img: img71,
        specs: [
            "1200x3000x1000 mm",
            "Rotary Probe Head – Revo 5",
            "MPE : ± 1.9 +L/350 m"
        ]
    },
    {
        title: "Universal Length Measuring System",
        img: img72,
        specs: [
            "External Range :",
            "1. For plain – 680mm",
            "2. For thread – 480mm",
            "Internal Range :",
            "1. For Plain – 480mm",
            "2. For thread – 3 to 400mm",
            "Accuracy : 0.18 + L/1200 m"
        ]
    },
    {
        title: "Roundness Tester - Manual",
        img: img73,
        specs: [
            "X axis-180mm Z axis-300mm",
            "Workpiece Dia – 210mm Max",
            "Centering & Tilting - Manual",
            "Table Max load – 20 Kg",
            "Probe System – tactile 1D"
        ]
    },
    {
        title: "Roughness Tester",
        img: img74,
        specs: [
            "Range : ± 250 m",
            "Profile Types : D, P, W, R",
            "Cut off : 0.025, 0.25, 0.80, 2.5, 8.0mm"
        ]
    },


    {
        title: "Cleanliness Lab – Microscopic Analysis",
        img: img75,
        specs: [
            "Range : 4” x 4” to 8” x 4”",
            "Zoom : 5x, 10x, 25x",
            "4500K Led illumination"
        ]
    },
    {
        title: "Cleanliness Lab – Gravimetric Analysis",
        img: img76,
        specs: [
            "Range : 0- 220 g",
            "L.C : 0.0001 g"
        ]
    },
    {
        title: "Weighing Balance",
        img: img77,
        specs: [
            "Range : 0- 75 kg",
            "L.C : 0.005 Kg"
        ]
    },
    {
        title: "Digital Contamination Monitor",
        img: img78,
        specs: [
            "Radiation detection : Alpha, Beta, Gamma & X-ray",
            "Dose Rate :",
            "0.01mR/h to 200mR/h",
            "0.1 Sv/h to 2 mSv/h",
            "0.1Gy/h to 2 mGy/h"
        ]
    },
    {
        title: "Gauge Block",
        img: img79,
        specs: [
            "Range 0.5-100 mm (112 nos)",
            "Grade 0"
        ]
    },
    {
        title: "Non-Ferrous Coating thickness Gauge",
        img: img80,
        specs: [
            "Range : 0-2000 m",
            "Measuring units : m or mils",
            "Trueness :",
            "0 to 50 μm: ≤ 1 μm",
            "50 to 1000 μm: ≤ 2 % of reading",
            "1000 ... 2000 μm: ≤ 3 % of reading"
        ]
    },
    {
        title: "Caliper Checker",
        img: img81,
        specs: [
            "Range 0-600mm"
        ]
    },
    {
        title: "Depth Checker",
        img: img82,
        specs: [
            "Range 0-300mm"
        ]
    },

];

function Machining() {
    return (
        <div className="container">
            {instruments.map((item, index) => (
                <div className="card" key={index}>
                    <h2>{item.title}</h2>
                    <img src={item.img} alt={item.title} />
                    <div className="specs">
                        <h3>Specifications</h3>
                        <ul>
                            {item.specs.map((s, i) => (
                                <li key={i}>{s}</li>
                            ))}
                        </ul>
                    </div>
                </div>
            ))}
        </div>
    );
}

export default Machining;
